"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _formItem = _interopRequireDefault(require("./form-item"));
var _xeUtils = _interopRequireDefault(require("xe-utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = {
  name: 'VxeFormGather',
  extends: _formItem.default,
  provide: function provide() {
    return {
      $xeformgather: this,
      xeformitem: null,
      $xeformiteminfo: this
    };
  },
  render: function render(h) {
    var $xeform = this.$xeform,
      className = this.className,
      field = this.field,
      itemConfig = this.itemConfig;
    var span = this.span || ($xeform ? $xeform.props.span : null);
    return $xeform && $xeform.customLayout ? h('div', {
      class: ['vxe-form--gather vxe-form--item-row', itemConfig.id, span ? "vxe-form--item-col_".concat(span, " is--span") : '', className ? _xeUtils.default.isFunction(className) ? className({
        $form: $xeform,
        data: $xeform ? $xeform.props.data : {},
        item: itemConfig,
        field: field,
        property: field
      }) : className : '']
    }, this.$slots.default) : h('div');
  }
};